import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterOutlet} from '@angular/router';
import {environment} from '../environments/environment';
import {ToastListComponent} from './core/components/toast-list/toast-list.component';
import {FooterComponent} from './shared/layout/footer/footer.component';
import {NavigationBarComponent} from './shared/layout/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NavigationBarComponent,
    RouterOutlet,
    FooterComponent,
    ToastListComponent,
  ],
})
export class AppComponent {
  constructor() {
    if (!environment.production) {
      inject(Title).setTitle('FIT [Dev]');
    }
  }
}
